<template>
  <el-dialog title="故障现象" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: 0px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="table_main" style="height: 400px!important;">
          <div class="form_class">
            <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                      :data="formData" @submit="searchEvent" @reset="searchEvent">
              <vxe-form-item title="现象编码:" field="itemName">
                <template v-slot>
                  <el-input v-model="searchSymptomCode" size="small" clearable/>
                </template>
              </vxe-form-item>
              <vxe-form-item title="现象名称:" field="itemName">
                <template v-slot>
                  <el-input v-model="searchSymptomName" size="small" clearable/>
                </template>
              </vxe-form-item>
            </vxe-form>
            <div class="clearfix screen-btns">
              <div class="fr" style="display: inline-block; float: right; margin-top: -39px;">
                <vxe-button status="warning" style="height: 26px; margin-top: 7px" icon="el-icon-search"
                            class="button-sty"
                            @click="searchEvent">搜索
                </vxe-button>
              </div>
            </div>
          </div>
          <vxe-table style="margin-top: 5px;"
                     :stripe="true"
                     :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', }"
                     :row-config="{ isHover: true, padding: 0, labelField: 'id', keyField: 'id'}"
                     :row-style="{ fontSize: '12px', height: '36px', padding: '0'}"
                     :cell-style="{  height: '36px' }"
                     show-overflow
                     :checkbox-config="{ labelField: '', highlight: false, reserve: true, range: true }"
                     @checkbox-change="xTableChecked"
                     @checkbox-all="xTableChecked"
                     ref="xTable"
                     height="80%"
                     :column-config="{ resizable: true }"
                     :data="xTableData"
          >
            <vxe-column type="checkbox" width="40"/>
            <vxe-column title="故障现象编码" field="symptomCode" width="180"></vxe-column>
            <vxe-column title="故障现象名称" field="symptomName" width="200"></vxe-column>
            <vxe-column title="产品大类" field="bigCategoryName" width="200"></vxe-column>
            <vxe-column title="产品小类" field="smallCategoryName" width="200"></vxe-column>
            <vxe-column title="启用" field="usable" width="100">
              <template #default="{row}">
                <div v-if="row.usable == 0" class="txt-status disable">
                  <span>禁用</span>
                </div>
                <div v-else class="txt-status">
                  <span>启用</span>
                </div>
              </template>
            </vxe-column>
            <vxe-column title="创建时间" field="createTime" width="200"></vxe-column>
            <vxe-column title="创建人" field="createBy" width="150"></vxe-column>
          </vxe-table>

          <div style="float: left; height: 32px; font-size: 12px">
            <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
          </div>
        </div>
      </div>
    </template>
    <label id="labBtn" class="transverse">
      <div class="icon">
        <i class="el-icon-more"></i>
        <i class="el-icon-more"></i>
      </div>
    </label>
    <div class="multipleChoice">
      <el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
        <a class="allDel icon-quanbushanchu" @click="clearAllChecked()"></a>
      </el-tooltip>
      <div class="list">
        <div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
          <p>{{ checkRow.symptomName }}</p>
          <a class="el-icon-close" @click="clearChecked(checkRow)"></a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">

			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="confirm" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import checkboxTable from "@/mixins/selectDialog/checkboxTable";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'excludeIdList', 'bigCategoryId', 'smallCategoryId'],
  mixins: [checkboxTable],
  components: {pager},

  created() {
    this.$objCopy(this.param, this.formData)
    // this.initSetting();
    if (this.excludeIdList) {
      this.formData.excludeIdList = this.excludeIdList
    }
    if (this.bigCategoryId) {
      this.formData.bigCategoryId = this.bigCategoryId
    }
    if (this.smallCategoryId) {
      this.formData.smallCategoryId = this.smallCategoryId
    }
    if (this.symptomId) {
      this.formData.symptomId = this.symptomId
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      total: 0,
      filterText: '',
      data: [],
      checkedArray: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        usable: 1,
        symptomCode: '',  // 故障现象编码
        symptomName: null,
        excludeIdList: null,
        bigCategoryId: null,
        smallCategoryId: null,
        itemCategoryIdList: [],
      },

      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSymptomCode: '',
      searchSymptomName: null,
    };
  },


  methods: {
    getTableData() {
      this.$http.post(api.basFaultSymptom.getTableDataUrl, this.formData).then(res => {
        this.total = res.data.data.total
        this.xTableData = res.data.data.records
      })
    },


    flushed() {
      this.checkedArray = []
      this.$refs['table-m1'].commitProxy('reload');
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.getTableData()
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.formData.symptomCode = this.searchSymptomCode
      this.formData.symptomName = this.searchSymptomName
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    // initTableList() {
    //   let tableOption = {
    //     vue: this,
    //     tableRef: 'table-m1',
    //     tableName: 'basic_fault_code_list-m1',
    //     path: api.basFaultSymptom.getTableDataUrl,
    //     param: this.formData,
    //     method: 'post',
    //     columns: this.columns
    //   };
    //   this.vxeOption = initVxeTable(tableOption)
    //   this.flushed()
    // },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep body .dialog-style.list-dialog .el-dialog__body {
  background: #F1F5FB;
  padding: 8px 0px 1px !important;
  height: 575px;
}

// ::v-deep .grid-height {
// 	height: calc(100vh - 270px) !important;
// }
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -40px !important;
  position: absolute !important;
  z-index: 9;
  background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}

::v-deep .vxe-form--wrapper .vxe-row {
  background-color: #f6f8fb;
}

::v-deep .vxe-form--item {
  font-size: 12px;
  padding: 0;
  margin-left: 7px;
  margin-right: 7px;
}

::v-deep .vxe-pager {
  height: 30px;
}
</style>
